import css from "PFApp/activities/show/activity_page/activity_page.module.scss";
import { useActivityShortlists } from "PFApp/activities/show/hooks/use_activity_shortlists";
import { useFiltersV2Store } from "PFApp/components/filters_v2";
import { Stack } from "PFComponents/containers";
import { RefObject } from "react";
import { useTranslation } from "react-i18next";

import { ActivityReviewSection } from "../../../../../parts/review_section";
import { ActivitySidePanelFilters } from "../../components/activity_side_panel_filters";
import { ShortlistInformation } from "./shortlist_information";

type ShortlistSidePanelProps = {
  scrollableContainerRef: RefObject<HTMLDivElement | null>;
};

export const ShortlistSidePanel = ({ scrollableContainerRef }: ShortlistSidePanelProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.sidePanel.filters" });

  const { isLoadingShortlists } = useActivityShortlists();

  const filters = useFiltersV2Store((state) => state.buffer.mainFilters);

  return (
    <Stack gap="spacingLg" className={css.pageCardSidePanel}>
      <ShortlistInformation />
      <ActivityReviewSection />
      <ActivitySidePanelFilters
        filters={filters}
        disabled={isLoadingShortlists}
        scrollableContainerRef={scrollableContainerRef}
        moreFiltersTitle={t("shortlistFilters")}
        clearMoreFiltersTitle={t("clearShortlistFilters")}
        restoreMoreFiltersTitle={t("restoreShortlistFilters")}
      />
    </Stack>
  );
};
